import React from 'react'
import { Col } from "react-bootstrap";

export function renderOptionsField(field)
{
  //  const handleOnChange = field.onChange ? field.onChange:null
    return (
        <div className='form-group'>
            <label className={field.labelattrs}>{field.label}</label>
            <Col  className={field.inputattrs}>
         
            {field.values.map(function(value) {

                    return ( 
                                <label key={value.abbreviation} className="radio-inline c-radio">
                                    <input  {...field.input}  type="radio" name={field.id} value={value.abbreviation}  
                                            checked={value.abbreviation === field.defaultvalue}
                                            disabled={value.disabled}
                                    />
                                    <em className="fa fa-circle" />&nbsp;&nbsp;{value.name}
                                </label> 
                            )
                })}
            </Col>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/modules/components/fieldoptioncomponent.js